import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { filterRelevantValues } from '../../utils/utils.js';
import { DropDown_Values, DropDown_Variable } from '../../../../../../shared-components/index.js';
import { ModuleFE_Variable, ModuleFE_Value } from '../../../../../../../_entity.js';
import React from 'react';
export default function RenderRightSide(props) {
    const [relevantIds, setRelevantId] = React.useState([]);
    React.useEffect(() => {
        props.item?.map(currInput => {
            if (currInput.variableId) {
                setRelevantId([...relevantIds,
                    filterRelevantValues(getValueOfSelectedVariable(currInput.variableId))]);
            }
        });
    }, []);
    const getValueOfSelectedVariable = (id) => {
        const variable = ModuleFE_Variable.cache
            .unique(id);
        return ModuleFE_Value.cache
            .find((v) => {
            return v._id === variable?.valueId;
        });
    };
    return _jsx(_Fragment, { children: props.item && props.item?.map((currInputMenu, inputIndex) => (_jsxs("div", { style: { width: '100%' }, className: 'due-dropdown-flex', children: [_jsx(DropDown_Variable, { selected: props.item[inputIndex]?.variableId ? props.item[inputIndex].variableId : '', onSelected: variable => {
                        props.onChangeVariableToCompare(props.index, inputIndex, variable);
                        setRelevantId(prevState => {
                            const newIds = filterRelevantValues(getValueOfSelectedVariable(variable._id));
                            if (prevState[inputIndex]) {
                                prevState[inputIndex] = newIds;
                            }
                            else {
                                prevState.push(newIds);
                            }
                            return prevState;
                        });
                    }, sortBy: ['name'] }), props.item[inputIndex]?.variableId ?
                    _jsxs(_Fragment, { children: [_jsx("div", { className: 'separator' }), _jsx(DropDown_Values, { onSelected: value => {
                                    props.onChangeValueToCompare(props.index, inputIndex, value);
                                }, queryFilter: item => relevantIds[inputIndex]?.includes(item._id), selected: props.item && props.item[inputIndex].valueId, variable: props.variable })] }) : null] }, inputIndex))) });
}
//# sourceMappingURL=RenderRIghtSide.js.map